class HomepageAdTagBuilder {
    constructor() {
        this.adZoneSite = this.getSite();
        this.adZone = this.buildAdZone();
        this.adUrl = this.buildAdURL();
    }

    buildAdURL() {
        let tag = 'https://pubads.g.doubleclick.net/gampad/ads?' +
        'sz=640x360' +
        '&impl=s' +
        '&gdfp_req=1' +
        '&env=vp' +
        '&output=vast' +
        '&unviewed_position_start=1' +
        '&vad_type=linear' +
        '&vpos=preroll' +
        '&correlator=' + Date.now() +
        '&iu=' + this.adZone +
        // Custom Params:
        // TESTING:
        // '&cust_params=cms%3Ddfp_video_test';
        // PRODUCTION:
        '&cust_params=video_tags%3D__item-tags__' +
        '%26vport=' + this.getViewport() +
        '%26video_id=__item-mediaid__';

        return tag;
    }

    buildAdZone() {
        let adZoneArray = ['', '4160', this.adZoneSite, 'studios', 'homepage', 'preroll_homepage'];
        return adZoneArray.join('/');
    }

    getSite() {
        switch (true) {
        case window.location.href.match(/fastcompany/) !== null:
            return 'mv.fc';
        case window.location.href.match(/fastcodesign/) !== null:
            return 'mv.fcdesign';
        case window.location.href.match(/fastcoexist/) !== null:
            return 'mv.fcexist';
        case window.location.href.match(/fastcocreate/) !== null:
            return 'mv.fccreate';
        default:
            return 'mv.fc';
        }
    }

    getViewport() {
        let w = window.innerWidth;

        if (w > 1023) {
            return 'l';
        }

        if (w < 640) {
            return 's';
        }

        return 'm';
    }
}

export default new HomepageAdTagBuilder();
